/* ==========================================================================
   Mi Jardín — Landing futurista (hero-3d.js)
   Recorte de fondo (canvas), parallax 3D, partículas de fibra de carbono.
   Vanilla JS, sin dependencias.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-lp]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* -------------------- Animación de entrada -------------------- */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { root.classList.add('is-loaded'); });
  });

  /* -------------------- Recorte del fondo blanco -------------------- */
  var plant = root.querySelector('[data-plant]');
  var plantImg = root.querySelector('[data-plant-img]');
  if (plantImg && plant) chromaKey(plantImg, plant);

  function chromaKey(displayImg, container) {
    var src = displayImg.getAttribute('src');
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var maxDim = 1100;
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h) return;
        var scale = Math.min(1, maxDim / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(probe, 0, 0, cw, ch);
        var imgData = ctx.getImageData(0, 0, cw, ch); // lanza si está "tainted"
        var d = imgData.data;
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], b = d[i + 2];
          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var lum = 0.299 * r + 0.587 * g + 0.114 * b;
          var sat = max - min;
          if (lum > 234 && sat < 22) {
            d[i + 3] = 0;
          } else if (lum > 214 && sat < 26) {
            var t = (234 - lum) / 20; // 0..1 difuminado del borde
            if (t < 0) t = 0; if (t > 1) t = 1;
            d[i + 3] = Math.round(d[i + 3] * t);
          }
        }
        ctx.putImageData(imgData, 0, 0);
        displayImg.src = canvas.toDataURL('image/png');
        container.classList.add('is-cut');
      } catch (e) {
        /* canvas bloqueado por CORS: se mantiene el fallback mix-blend-mode: multiply */
      }
    };
    probe.onerror = function () { /* sin CORS: fallback multiply */ };
    probe.src = src;
  }

  /* -------------------- Parallax 3D (sigue al cursor) -------------------- */
  if (!reduce && finePointer) initParallax();
  function initParallax() {
    var title = root.querySelector('[data-title]');
    var cx = 0, cy = 0, tx = 0, ty = 0, running = false;

    function onMove(e) {
      var r = root.getBoundingClientRect();
      cx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      cy = ((e.clientY - r.top) / r.height - 0.5) * 2;
    }
    function onLeave() { cx = 0; cy = 0; }
    function loop() {
      tx += (cx - tx) * 0.08;
      ty += (cy - ty) * 0.08;
      if (plant) {
        plant.style.transform = 'perspective(1100px) rotateY(' + (tx * 9).toFixed(2) + 'deg) rotateX(' + (-ty * 7).toFixed(2) + 'deg)';
      }
      if (title) {
        title.style.transform = 'translate(calc(-50% + ' + (tx * -14).toFixed(1) + 'px), calc(-50% + ' + (ty * -9).toFixed(1) + 'px))';
      }
      requestAnimationFrame(loop);
    }
    // Esperar a que termine la animación de entrada antes de tomar el control
    setTimeout(function () {
      if (running) return;
      running = true;
      if (plant) plant.style.transition = 'none';
      if (title) title.style.transition = 'none';
      root.addEventListener('pointermove', onMove, { passive: true });
      root.addEventListener('pointerleave', onLeave, { passive: true });
      loop();
    }, 1250);
  }

  /* -------------------- Partículas de fibra de carbono -------------------- */
  if (!reduce) initParticles();
  function initParticles() {
    var canvas = root.querySelector('[data-particles]');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, parts = [], raf = null;
    var mouse = { x: -9999, y: -9999 };
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var COUNT = isMobile ? 24 : 62;

    function resize() {
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function build() {
      parts = [];
      for (var i = 0; i < COUNT; i++) {
        parts.push({
          x: Math.random() * W, y: Math.random() * H,
          len: 8 + Math.random() * 26,
          ang: Math.random() * Math.PI,
          vx: (Math.random() - 0.5) * 0.22,
          vy: (Math.random() - 0.5) * 0.22,
          va: (Math.random() - 0.5) * 0.009,
          op: 0.05 + Math.random() * 0.14,
          w: 0.6 + Math.random() * 1.3
        });
      }
    }
    function step() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        var dx = p.x - mouse.x, dy = p.y - mouse.y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 130 && dist > 0.001) {
          var f = (130 - dist) / 130;
          p.x += (dx / dist) * f * 2.4;
          p.y += (dy / dist) * f * 2.4;
          p.ang += f * 0.06; // arremolinado
        }
        p.x += p.vx; p.y += p.vy; p.ang += p.va;
        if (p.x < -40) p.x = W + 40; else if (p.x > W + 40) p.x = -40;
        if (p.y < -40) p.y = H + 40; else if (p.y > H + 40) p.y = -40;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.ang);
        var grad = ctx.createLinearGradient(-p.len / 2, 0, p.len / 2, 0);
        grad.addColorStop(0, 'rgba(26,25,22,0)');
        grad.addColorStop(0.5, 'rgba(26,25,22,' + p.op + ')');
        grad.addColorStop(1, 'rgba(26,25,22,0)');
        ctx.strokeStyle = grad;
        ctx.lineWidth = p.w;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(-p.len / 2, 0);
        ctx.lineTo(p.len / 2, 0);
        ctx.stroke();
        ctx.restore();
      }
      raf = requestAnimationFrame(step);
    }
    function start() { if (!raf) step(); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect();
      mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
    }, { passive: true });
    root.addEventListener('pointerleave', function () { mouse.x = -9999; mouse.y = -9999; }, { passive: true });
    window.addEventListener('resize', function () { resize(); build(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    resize(); build(); start();
  }
})();
